import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  useTransGetChainsQuery,
  useTransGetChainsWithdAddrQuery,
  useTransRaiseWithdrawRequestMutation,
  useTransWithdModelCommissionDataQuery,
} from "../../redux/TransactionApi";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useRef } from "react";

function WithdrawalModal({ open, onClose, editData }) {
  const [selectedChain, setSelectedChain] = useState("0");
  const [walletAddress, setWalletAddress] = useState("");
  const [isSelfWallet, setIsSelfWallet] = useState(false);
  const [amount, setAmount] = useState("");
  const [btnDisabled, setButtonDisabled] = useState(false);

  const [errors, setErrors] = useState({});

  const { data: commissionDetails } = useTransWithdModelCommissionDataQuery({
    currency_id: editData?.currency_id,
  });

  const { data: chains, isLoading } = useTransGetChainsQuery(
    { symbol: editData?.symbol },
    { skip: !open }
  );

  const {
    data: chainsAddr,
    isLoading: isLoadingAddr,
    isFetching,
    error: chainsAddrError,
  } = useTransGetChainsWithdAddrQuery(
    { chain_id: selectedChain },
    {
      skip: selectedChain == 0 || !open,
      // refetchOnMountOrArgChange: true,
    }
  );

  const swalShownRef = useRef(false);

  useEffect(() => {
    if (!open) return;
    if (!chainsAddrError) {
      swalShownRef.current = false;
      return;
    }
    if (chainsAddrError && !swalShownRef.current) {
      swalShownRef.current = true;

      Swal.fire({
        title: "No address found",
        text: "Do you want to whitelist your withdrawal address?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, whitelist",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        swalShownRef.current = false;

        if (result.isConfirmed) {
          window.location.href = "/whitelist";
        } else {
          handleClose();
          toast.dismiss();
        }
      });
    }
  }, [chainsAddrError, open]);

  const [transRaiseWithdrawRequest, { isLoading: isSubmitting }] =
    useTransRaiseWithdrawRequestMutation();

  const handleSelectChain = (e) => {
    const value = e.target.value;
    setSelectedChain(value);
    setErrors((prev) => ({ ...prev, selectedChain: "" }));

    if (value === "0") {
      setWalletAddress("");
    }
  };

  useEffect(() => {
    if (!open) return;

    if (selectedChain === "0") {
      setWalletAddress("");
      return;
    }

    if (isLoadingAddr || isFetching) {
      setWalletAddress("");
      return;
    }

    if (chainsAddr?.wallet_address) {
      setWalletAddress(chainsAddr.wallet_address);
    } else {
      setWalletAddress("");
    }
  }, [chainsAddr, selectedChain, open, isLoadingAddr, isFetching]);

  const handleClose = () => {
    setSelectedChain("0");
    setWalletAddress("");
    setAmount("");
    setErrors({});
    setIsSelfWallet(false)
    onClose();
  };

  const validate = () => {
    let newErrors = {};

    if (!selectedChain || selectedChain === "0") {
      newErrors.selectedChain = "This field is required";
    }

    if (!amount) {
      newErrors.amount = "This field is required";
    } else if (isNaN(amount) || Number(amount) <= 0) {
      newErrors.amount = "Enter a valid number";
    } else if (
      commissionDetails?.data?.min_withdrawal &&
      Number(amount) < Number(commissionDetails?.data?.min_withdrawal)
    ) {
      newErrors.amount = `Minimum withdrawal is ${commissionDetails?.data?.min_withdrawal}`;
    } else if (
      editData?.wallet_balance &&
      Number(amount) > Number(editData?.wallet_balance)
    ) {
      newErrors.amount = "Insufficient balance";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRaiseRequest = async () => {
    if (!validate()) return;
    setButtonDisabled(true);
    setTimeout(() => setButtonDisabled(false), 3000);
    try {
      const payload = {
        currency_id: editData?.currency_id,
        chain_id: +selectedChain,
        amount: Number(amount),
        tds: isSelfWallet ? 1 : 0,
      };

      const { error, data } = await transRaiseWithdrawRequest(payload);
      toast.dismiss();
      if (error) {
        toast.error(error?.data?.message || "Failed to submit request");
      }

      if (data) {
        toast.success(data?.message);
        handleClose();
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <Modal
        show={open}
        onHide={handleClose}
        className="account-popup-outer"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Withdrawal</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="wallet-balance form-group row">
            <div className="col-12 mb-3">
              <span className="mb-0 form-control d-flex">
                Wallet Balance:
                <b className="ml-auto">
                  {editData?.wallet_balance} {editData?.symbol}
                </b>
              </span>
            </div>

            <div className="col-md-6 mb-3 mb-md-0">
              <span className="form-control d-flex">
                Min Withdrawal:{" "}
                <b className="ml-auto">
                  {commissionDetails?.data?.min_withdrawal}
                </b>
              </span>
            </div>

            <div className="col-md-6">
              <span className="form-control d-flex">
                Withdrawal Fees:
                {console.log(commissionDetails?.data?.fees_type,commissionDetails, 'hello')}
                <b className="ml-auto">
                  {commissionDetails?.data?.withdrawal_commission}{" "}
                  {commissionDetails?.data?.fees_type === "flat" ? "" : "%"}
                </b>
              </span>
            </div>
          </div>

          <div>
            <div className="form-group">
              <label className="mb-0">Coin</label>
              <select
                className="form-control"
                value={selectedChain}
                onChange={handleSelectChain}
              >
                <option value={"0"}>Select Chain</option>
                {!isLoading &&
                  chains?.data?.map((chain) => (
                    <option key={chain?.chainId} value={chain?.chainId}>
                      {chain?.chainName}
                    </option>
                  ))}
              </select>
              {errors.selectedChain && (
                <small className="text-danger">{errors.selectedChain}</small>
              )}
            </div>

            <div className="form-group">
              <label className="mb-0">Amount</label>
              <div className="relative">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Amount"
                  value={amount}
                  onChange={(e) => {
                    let val = e.target.value;

                    if (/^\d{0,7}(\.\d{0,8})?$/.test(val)) {
                      setAmount(val);
                      setErrors((prev) => ({ ...prev, amount: "" }));
                    }
                  }}
                />
                <span className="absolute_btc">{editData?.symbol}</span>
              </div>
              {errors.amount && (
                <small className="text-danger">{errors.amount}</small>
              )}
            </div>

            <div className="form-group">
              <label className="mb-0">Address</label>
              <div className="relative">
                <input
                  type="text"
                  className="form-control"
                  value={
                    isLoadingAddr || isFetching
                      ? "Loading address..."
                      : walletAddress
                  }
                  placeholder="No Wallet Address"
                  disabled
                />
              </div>
              {errors.walletAddress && (
                <small className="text-danger">{errors.walletAddress}</small>
              )}
              <div className="form-group mb-0 mt-2">
                <input
                  type="checkbox"
                  id="check1"
                  checked={isSelfWallet}
                  onChange={(e) => setIsSelfWallet(e.target.checked)}
                />
                <label htmlFor="check1" className="ml-2">
                  Transfer to self wallet (Consent No TDS)
                </label>
              </div>
            </div>

            <div className="tc">
              <button
                className="btn btn_man fs14"
                onClick={handleRaiseRequest}
                disabled={isSubmitting || btnDisabled}
              >
                Withdraw Amount
              </button>
            </div>

            <div>
              <div className="not_box">
                <h5>Note</h5>
                <h6 className="mb-0">Consent:</h6>
                <p className="mt-1">
                  If you haven't given consent, TDS will be deducted. No TDS
                  applies when transferring assets to your own wallet or another
                  exchange account.
                </p>
                <h6>TDS details:</h6>
                <ol>
                  <li>
                    Income Tax Section 194S mandates a {commissionDetails?.data?.tds??0}% TDS deduction on the
                    sale of Virtual Digital Assets by Indian residents.
                  </li>
                  <li>
                    Green Crypto deducts TDS on
                    behalf of the buyer.
                  </li>
                  <li>
                    TDS rate varies to 5%, subject to Section 206AB, or 20% if
                    Aadhar and PAN card are not linked.
                  </li>
                </ol>

                <h6 className="mt-4">
                  <i
                    className="fa fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>{" "}
                  Disclaimer
                </h6>
                <ol>
                  <li>
                    Send only using the correct network. Using any other network
                    will result in loss of funds.
                  </li>
                  <li>
                    Deposit only to this deposit address. Depositing any other
                    asset will result in a loss of funds.
                  </li>
                </ol>
              </div>
            </div>

            {/* <div className="disclaimer-main   w-100 pl-0 pr-0 mt-3">
              <div className="disclaimer-outer not_box">
                <h6>
                  <i
                    className="fa fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>{" "}
                  Disclaimer
                </h6>
                <ol>
                  <li>
                    Send only using the correct network. Using any other network
                    will result in loss of funds.
                  </li>
                  <li>
                    Deposit only to this deposit address. Depositing any other
                    asset will result in a loss of funds.
                  </li>
                </ol>
              </div>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default WithdrawalModal;
